import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onSubmit"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useRouter } from "next/router";
import { SearchInputField } from "./Parts/index";

var IconSearch = function IconSearch(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      clipRule: "evenodd",
      fill: "none",
      stroke: "#AAA",
      strokeWidth: "1.32",
      strokeMiterlimit: "10",
      cx: "7.75",
      cy: "7.75",
      r: "7"
    }), /*#__PURE__*/_jsx("path", {
      clipRule: "evenodd",
      fill: "none",
      stroke: "#AAA",
      strokeWidth: "1.32",
      strokeMiterlimit: "10",
      d: "M19.463 19.463 12.7 12.7"
    })]
  }));
};

IconSearch.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  xmlSpace: "preserve"
};
import styles from "@/styles/Form.module.scss";
import { useDeviceInfoQuery } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SearchForm(_ref) {
  var _router$query;

  var onSubmit = _ref.onSubmit,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useForm = useForm(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      setValue = _useForm.setValue,
      reset = _useForm.reset;

  var router = useRouter();
  var searchQuery = router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.q;

  var _useDeviceInfoQuery = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  }),
      data = _useDeviceInfoQuery.data;

  var deviceInfo = data === null || data === void 0 ? void 0 : data.deviceInfo;
  var handleKeyDown = useCallback(function (e) {
    // Return
    if (e.key === "Enter" && deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isMobile) {
      setTimeout(function () {
        e.target.blur();
      }, 200);
    }
  }, [deviceInfo]);
  useEffect(function () {
    if (router.pathname === "/search" && searchQuery) {
      setValue("search", searchQuery);
    }
  }, [router.asPath, searchQuery]);
  useEffect(function () {
    var handleRouteChange = function handleRouteChange(url) {
      if (!~url.indexOf("/search")) {
        reset({
          search: ""
        });
      }
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return function () {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, []);
  return /*#__PURE__*/_jsxs("form", {
    action: "#",
    onSubmit: handleSubmit(onSubmit),
    className: styles.searchForm,
    noValidate: true,
    children: [/*#__PURE__*/_jsx(SearchInputField, _objectSpread({
      ref: register,
      name: "search",
      onKeyDown: handleKeyDown,
      placeholder: "\u30B5\u30A4\u30C8\u5185\u691C\u7D22"
    }, props)), /*#__PURE__*/_jsx("button", {
      type: "submit",
      className: styles.searchFormSubmitBtn,
      children: /*#__PURE__*/_jsx(IconSearch, {})
    })]
  });
}